
import { Context } from '@nuxt/types'
import Vue, { PropType } from 'vue'
import { formatDate } from '~/domain/helpers/formatters'
import { UserType } from '~/domain/interfaces'
export default Vue.extend({
  name: 'ProfileCard',
  props: {
    user: {
      type: Object as PropType<UserType>,
      required: true,
    },
    following: Number,
    followers: Number,
    isDesignerForHire: Boolean,
    accountEqualsAuthenticatedUser: Function,
  },
  data() { 
    return {
      avatarSize: 120
    }
  },
  methods: {
    getLocation(){
      if (this.user?.location?.city) {
        return this.user?.location?.city + ' ' + this.user?.location?.countryCode 
      } else return this.user?.location?.country
    },
    hirePressed(){
      this.$emit('hirePressed')
    },
    getMemberDate(){
      if(this.user?.createdAt)
        return 'Member since ' + formatDate(this.user?.createdAt, "MMM YYYY")
      else return ''
    }
  },
  computed:{
    isProfileNotCurrentUser(): Boolean{
      const authenticatedUser = this.$store.getters['authenticatedUser'];

      return ! (authenticatedUser && authenticatedUser?.email === this.user?.email);
    }
  }
})
